export const Stats = () => {
  const stats = [
    {
      number: '50,000+',
      label: 'Appointments Booked',
      description: 'Qualified homeowner appointments delivered to contractors',
    },
    {
      number: '$500M+',
      label: 'Revenue Generated',
      description: 'Total contract value generated for our partners',
    },
    {
      number: '500+',
      label: 'Active Contractors',
      description: 'Home service businesses growing with RenoNovo',
    },
    {
      number: '87%',
      label: 'Close Rate',
      description: 'Average appointment-to-contract conversion rate',
    },
  ];

  return (
    <section className="py-20 md:py-32 bg-[#0f172a]" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm tracking-wide uppercase font-semibold text-[#2563eb] mb-4">
            Proven Results
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
            Numbers That Speak for Themselves
          </h2>
          <p className="text-lg text-white/70 leading-relaxed">
            Our track record demonstrates our commitment to delivering real, measurable results 
            for home service contractors across the nation.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              data-testid={`stat-${index}`}
              className="text-center p-8 border border-white/10 rounded-sm hover:border-[#2563eb]/50 transition-colors duration-300 group"
            >
              <p className="text-4xl md:text-5xl font-bold text-[#2563eb] mb-3 group-hover:scale-105 transition-transform duration-300">
                {stat.number}
              </p>
              <p className="text-lg font-semibold text-white mb-2">{stat.label}</p>
              <p className="text-sm text-white/60">{stat.description}</p>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full">
            <div className="flex -space-x-2">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="w-8 h-8 bg-[#2563eb] rounded-full border-2 border-[#0f172a] flex items-center justify-center">
                  <span className="text-xs text-white font-bold">{i}</span>
                </div>
              ))}
            </div>
            <p className="text-white/80 text-sm">
              Join <span className="text-white font-semibold">500+</span> contractors growing with RenoNovo
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
